module.exports = __webpack_public_path__ + "images/945f8e19bea02aa40172c7dba5c8a7a6.png";